import BaseService from '@/services/base_service';

export default class StateService extends BaseService {
    list(params) {
        return new Promise((resolve, reject) => {
            axios.get('/estado', params).then(response => {
                resolve(response);
            }).catch(e => {
                reject(e);
            });
        });
    }
}



// WEBPACK FOOTER //
// ./src/services/state.js